<template>
  <section>
    <div class="card">
      <div class="card-header">{{ $t('message.menu.payment_method') }}</div>
      <div class="card-body">
        <user-credit-cards ref="userCreditCard" :canEditCard="true"></user-credit-cards>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import UserCreditCards from './UserCreditCards'
  import axios from 'axios'

  export default {
    components: {
      UserCreditCards
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('payment', [
        'tmpOmiseChargeId',
        'tmpOmiseToken',
        'tmpIsDefaultCard'
      ])
    },
    methods: {
      async checkOmiseTestCharge () {
        const url = `/payments/${this.user.id}/check-omise-test-charge`
        const { data } = await axios.post(url, { omise_charge_id: this.tmpOmiseChargeId })
        if (data) {
          const omiseTestCharge = data.omise_test_charge
          switch (omiseTestCharge.status) {
            case 0:
              setTimeout(() => {
                this.checkOmiseTestCharge()
              }, 2000)
              break
            case 1:
              this.saveNewCard()
              break
            case 2:
              this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
              const message = `${this.$i18n.t('message.booking.payment_step.payment_cannot_save_credit_card')} ${omiseTestCharge.failure_message}`
              this.$swal({ text: message, type: 'error' })
              break
          }
        }
      },
      async saveNewCard () {
        // Add new card
        const submitData = {
          user_id: this.user.id,
          omise_token: this.tmpOmiseToken,
          is_default: this.tmpIsDefaultCard
        }
        await this.$store.dispatch('payment/ADD_PAYMENT', submitData)
        // Fetch user credit cards
        await this.$refs.userCreditCard.fetchUserCreditCards()
      }
    },
    async mounted () {
      if (this.$route.query.tmpToken && this.$route.query.tmpToken === this.tmpOmiseToken) {
        // Clear omise token in query params
        const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)
        if (!isSafari) {
          this.$router.replace({ query: undefined })
        }
        // Check omise test charge
        this.checkOmiseTestCharge()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/payment/Index.vue